import documento from "..";

const routes = [
	{ name: "ContabilitaDocumentiListPage", path: "/contabilita/documenti", component: documento.ContabilitaDocumentiListPage, meta: { title: "Lista Contabilità" } },
	//  { name: "ContabilitaDocumentiViewPage", path: "/contabilita/documenti/view/:id", component: documento.ContabilitaDocumentiViewPage, meta: { title: "Dettaglio Contabilità" } },
	//  { name: "ContabilitaDocumentiEditPage", path: "/contabilita/documenti/edit/:id", component: documento.ContabilitaDocumentiEditPage, meta: { title: "Modifica Contabilità" } },
	//  { name: "ContabilitaDocumentoSoggettoListPage", path: "/contabilita/soggetto", component: documento.ContabilitaDocumentoSoggettoListPage, meta: { title: "Lista Soggetti" } },
];
export default routes;
